@import "../../variables";

.branchDetails {
  max-width: 1078px;
  margin: 0 auto 70px;

  @media (max-width: $size-lg) and (min-width: $size-md+1) {
    width: 660px;
    padding-bottom: 80px;
  }

  @media (max-width: $size-md) and (min-width: $size-sm+1) {
    width: 480px;
  }

  @media (max-width: $size-sm) {
    width: 100%;
    padding: 0 15px 48px;
  }

  &__container {
    @media (min-width: $size-sm + 1) {
      margin: 0 auto;
      padding: 0 30px;
    }
  }

  &__title {
    font-weight: 300;
    font-size: 28px;
    line-height: 34px;
  }

  &__content {
    height: 454px;
    display: flex;
    padding: 16px;
    background-color: white;
    border: 1px solid #E2E8F0;
    
    @media (max-width: $size-md) {
      flex-direction: column-reverse;
      height: unset;
    }
  }

  &__map {
    flex-grow: 1;

    @media (max-width: $size-md) {
      height: 240px;
      margin: 15px 0;
    }
  }

  &__info {
    flex: 0;
    position: relative;
    margin-left: 18px;
    font-size: 16px;

    @media (max-width: $size-lg) and (min-width: $size-md+1) {
      min-width: 285px !important;
    }

    @media (max-width: $size-md) {
      font-size: 12px;
      margin-left: 0;
    }

    &_name {
      font-size: 32px;
      line-height: 38.4px;
      font-weight: bold;

      @media (max-width: $size-md) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    &_address {
      margin-top: 8px;
      line-height: 19px;
      width: 225px;

      @media (max-width: $size-lg) and (min-width: $size-md+1) {
        max-width: 285px;
      }

      @media (max-width: $size-md) {
        line-height: 14.4px;
        width: 225px;
      }
    }

    &_button {
      margin-top: 9px;

      @media (max-width: $size-md) {
        margin-top: 8px;
      }

      &_bottom {
        position: absolute;
        bottom: 0;

        @media (max-width: $size-md) {
          display: none;
        }

        &_mobile {
          display: none;

          @media (max-width: $size-md) {
            display: block;
          }
        }
      }
    }

    &_opening {
      line-height: 24px;

      @media (max-width: $size-md) {
        line-height: 20px;
      }

      &_title {
        font-size: 20px;
        font-weight: bold;
        line-height: 24px;
        margin: 32px 0 8px;

        @media (max-width: $size-lg) and (min-width: $size-md+1) {
          width: 660px;
          margin-top: 24px;
        }

        @media (max-width: $size-md) {
          font-size: 16px;
          line-height: 19px;
          margin: 15px 0 4px;
        }
      }
    }

    &_contact {
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
      margin: 32px 0 6px;

      @media (max-width: $size-lg) and (min-width: $size-md+1) {
        margin-top: 24px;
      }

      @media (max-width: $size-md) {
        font-size: 16px;
        line-height: 19px;
        margin: 17px 0 3px;
      }

      &_link {
        line-height: 19.2px;
        font-weight: bold;
        text-decoration: underline;

        @media (max-width: $size-md) {
          font-size: 16px;
          line-height: 19px;
        }
      }
    }

    &_page {
      position: absolute;
      bottom: 0;
    }
  }
}
